<template>
  <el-dialog :title="dialogTitle" :visible.sync="editInstallPlanFormVisible" class="dialog_block" width="600" height="500" :close-on-click-modal="false">
    <el-form
      :model="installPlanForm"
      :rules="rules"
      ref="installPlanForm"
      label-width="100px"
      class="demo-dynamic"
    >
      <el-form-item label="计划日期" prop="planDate">
        <el-date-picker class="pro_workTime" v-model="installPlanForm.planDate" type="datetime" value-format="yyyy-MM-dd HH:mm"
                        placeholder="选择日期" :picker-options="pickerOptions" @change="changeTableDate">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="工人配置">
        <el-col :span="12">
        <el-form-item label="安装工:" prop="anzhuangNum">
          <el-input class="pro_el-input" maxlength="2" v-model="installPlanForm.anzhuangNum" placeholder="0"></el-input>
        </el-form-item>
        </el-col>
        <el-col :span="12">
        <el-form-item label="搬运工:" prop="banyunNum">
          <el-input class="pro_el-input" maxlength="2" v-model="installPlanForm.banyunNum" placeholder="0"></el-input>
        </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="安装内容" prop="content">
        <textarea v-model="installPlanForm.content"  maxlength="200" prefix-icon="el-icon-tickets" class="pro_bz mb_7" style="width:100%;" placeholder="请输入内容"></textarea>
      </el-form-item>
      <el-form-item label="加班安排"  prop="workOvertime">
        <el-radio v-model="installPlanForm.workOvertime" label="0" >无需加班</el-radio>
        <el-radio v-model="installPlanForm.workOvertime" label="1">需要加班</el-radio>
      </el-form-item>
    </el-form>
    <hr>
    <div class="foot_span">
      <el-button class="borderbtn width_80 fz_12" @click="save(1)">保存</el-button>
      <el-button class="blockbtn width_80 fz_12" @click="save(2)" v-if="!source">继续添加</el-button>
      <!-- <el-button @click="close">取 消</el-button> -->
    </div>
  </el-dialog>
</template>

<script>
import { objKeySort } from "@/util/ajaxsign";
export default {
  name: "editBasePlan",
  data() {
    return {
      editInstallPlanFormVisible: false,
      dialogTitle: "添加安裝计划",
      typeId:0,
      installPlanForm: {
        id: "",
        content: "",
        planDate: ""
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= new Date().getTime() - 86400000;
        }
      },
      rules: {
        planDate: [{ required: true, message: "请填写安裝日期", trigger: "blur" }],
        content: [{ required: true, message: "请填写安裝内容", trigger: "blur" }],
        workOvertime: [{ required: true, message: "请选择是否需要加班", trigger: "blur" }],
      }
    };
  },
  created() {

  },
  filters: {

  },
  methods: {

    //选择开工时间
    changeTableDate(e) {
      let that = this
      console.log("勘察日期：",e);
      that.installPlanForm.planDate = e
    },


    setData(type,data,source) {
      this.editInstallPlanFormVisible = true;
      this.cleanForm();
      this.source = source;
      this.typeId = type;
      if (data) {
        this.installPlanForm = data;
        this.dialogTitle = "修改安裝计划";
      } else {
        this.dialogTitle = "添加安裝计划";
        this.cleanForm();
      }
    },
    save(type) {
       let that =this
      that.$refs.installPlanForm.validate(valid => {
        if (valid) {
          if(!that.installPlanForm.anzhuangNum)
          that.installPlanForm.anzhuangNum = 0;
          if(!that.installPlanForm.banyunNum)
          that.installPlanForm.banyunNum = 0;




          that.$emit("setContent", 3,that.installPlanForm);
          if (type == 1) {
            that.close();
          } else {
            that.cleanForm();
          }
        } else {
          return false;
        }
      });
    },

    close() {
      this.editInstallPlanFormVisible = false;
      this.cleanForm();
    },
    cleanForm() {

        if(this.$refs.installPlanForm){
          this.$refs.installPlanForm.clearValidate();

          this.installPlanForm = {
            id: "",
            planDate:"",
            content: "",
            anzhuangNum: undefined,
            banyunNum: undefined,
            workOvertime:undefined,
            index:-1

          };
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .mb_7{
    margin-bottom: 7px;
  }
  .width_80{
    width: 80px;
    margin-top: 0;
  }
  .el-button{
   padding: 1px 16px;
  }
  .el-upload--picture-card{
    width: 125px;
    height: 125px;
    border-radius:3px;
    border:1px solid rgba(237,239,242,1);
    img{
      width: 100%;
      height: 100%;
      object-fit: contain !important;
    }
  }
  .el-upload-list__item{
    img{
      width: 100%;
      height: 100%;
      object-fit: contain !important;
    }
  }

  .foot_span{
    text-align: right;
    margin-right: 56px;
  }
  hr {
    bottom: 72px;
    border-color: rgba(245, 247, 250, 0.2);
    margin-bottom: 15px;
  }
  .el-dialog__body{
    padding: 0 !important;
  }
  .el-upload-list__item:first-child{
    margin-top: 0 !important;
  }
</style>
